const defaultQuote = {
  message: "It’s important for us to see how we're doing in real time, and we found the best way to do this is with Geckoboard.",
  author: "Mike Miner, Head of Customer Support, JustPark",
};

const defaultTitle = 'Make your own dashboard';
const defaultImage =  {
  src: '/uploads/ceo-overview-dashboard-example.png',
  alt: 'Dashboard example'
};

/*
 * dashboardExampleSignupCTAClickHandler is the click handler for the dashboard example CTA button
 * the button will be build with data attributes that contain the information required to update
 * the signup modal.
 *
 * This includes the title, dashboard image and also the user quote
 * If a user quote doesn't exist a default one will be used.
 *
 * We do it this way as one page can have upto 4 dashboard example CTA buttons
 * which require different context.
 *
 */
const dashboardExampleSignupCTAClickHandler = (e) => {
  e.preventDefault();

  const container = document.querySelector('#dashboard-examples-signup-container');
  if (!container) {
    console.warn('Unable to locate the dashboard examples signup container');
    return;
  }

  // Use current target for the actual current target with the data attributes
  // not the target that triggered the event
  const elem = e.currentTarget;

  const dashboardTitle = elem.getAttribute('data-de-signup-title');
  trackSignupFormViewed('Modal', dashboardTitle);

  // Track specifically that dashboard example
  // modal viewed in Matomo
  // TODO: Remove once we are happy with the event tracking
  if (window._paq) {
    window._paq.push(['trackGoal', 5]);
  }

  // The container exists so we expect all its children to exist too
  const dashboardImageElem = document.querySelector('#de-signup-dashboard-image');
  const titleElem = document.querySelector('#de-signup-title');
  const quoteMessageElem = document.querySelector('#de-signup-quote-message');
  const quoteAuthorElem = document.querySelector('#de-signup-quote-author');

  // Update the dashboard examples signup modal dynamic values
  // Use a fallback quote / image when one doesn't exist
  dashboardImageElem.setAttribute('src', elem.getAttribute('data-de-signup-image') || defaultImage.src);
  dashboardImageElem.setAttribute('alt', elem.getAttribute('data-de-signup-image-alt') || defaultImage.alt);
  quoteMessageElem.textContent = elem.getAttribute('data-de-signup-quote-message') || defaultQuote.message;
  quoteAuthorElem.textContent = elem.getAttribute('data-de-signup-quote-author') || defaultQuote.author;

  let titleContent = defaultTitle;

  if (dashboardTitle) {
    titleElem.textContent = `Make your own ${dashboardTitle}`;
  }

  container.style = 'display: flex';
}

/*
 * registerClickHandlerForDashboardExampleSignupModal runs only once on page load
 * it queries for links with specific hash href and adds a custom click handler
 * which handles opening the signup modal with its context.
 *
 * Also this adds a click handler for the signup modal close icon which when clicked
 * hides the modal overlay
 */
const registerClickHandlerForDashboardExampleSignupModal = () => {
  const elems = document.querySelectorAll('a[href="#dashboard-example-signup"]');

  const closeBtn = document.querySelector('#de-signup-close-button');
  if (closeBtn) {
    closeBtn.onclick = () => {
      const container = document.querySelector('#dashboard-examples-signup-container');
      container.style = 'display: none'
    };
  }

  for(const elem of elems) {
    elem.onclick = dashboardExampleSignupCTAClickHandler;
  }

  // Add blur fix for only firefox with an opacity
  if (navigator.userAgent.search('Firefox/') > -1) {
    const blurElements = document.querySelectorAll('span[class^="de-filter-blur-"]');
    for(const elem of blurElements) {
      elem.classList.add('firefox-blur-fix');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  registerClickHandlerForDashboardExampleSignupModal();
});
